/**
 * Termii SMS OTP — frontend client.
 *
 * Talks to the backend (`/api/send-otp`, `/api/verify-otp`). The backend
 * uses Termii's plain SMS endpoint (`/api/sms/send`) with a server-generated
 * 6-digit code. The Termii API key lives ONLY on the backend.
 *
 * No mocks, no hardcoded codes, no local fallback.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

if (!BACKEND_URL) {
    // eslint-disable-next-line no-console
    console.warn(
        "[Neyra] REACT_APP_BACKEND_URL is not set — OTP requests cannot reach the backend."
    );
}

/** Sends a 6-digit OTP to the phone via Termii SMS. */
export const sendOtp = async ({ identifier, purpose = "signup" } = {}) => {
    const phone = (identifier || "").trim();
    if (!phone) return { ok: false, error: "Phone number is required." };
    try {
        const { data } = await axios.post(`${BACKEND_URL}/api/send-otp`, {
            phone,
            purpose,
        });
        if (data?.success) {
            return { ok: true, pinId: data.pinId || null };
        }
        return { ok: false, error: data?.detail || "Could not send code." };
    } catch (err) {
        const detail =
            err?.response?.data?.detail ||
            err?.response?.data?.error ||
            err?.message;
        return { ok: false, error: detail || "Could not send code. Please try again." };
    }
};

/** Verifies an OTP code against a previously issued pinId. */
export const verifyOtp = async ({ pinId, code, identifier } = {}) => {
    if (!code) return { ok: false, error: "Enter the 6-digit code." };
    try {
        const { data } = await axios.post(`${BACKEND_URL}/api/verify-otp`, {
            pinId: pinId || null,
            phone: identifier || null,
            code,
        });
        if (data?.verified) return { ok: true };
        return { ok: false, error: data?.error || "Incorrect code. Please try again." };
    } catch (err) {
        const detail =
            err?.response?.data?.detail ||
            err?.response?.data?.error ||
            err?.message;
        return { ok: false, error: detail || "Verification failed." };
    }
};
